import React, { useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.css";
import brandImage from "../../assets/mcollectbrandimage.jpg";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/authSlice/authSlice";

const Sidebar = () => {
  const { loginData } = useSelector((store) => store.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  const menuItems = [
    {
      title: "Auctions",
      icon: "🔨",
      key: "auctions",
      submenu: [
        { title: "Auction List", path: "/auctions/list" },
        { title: "Create Auction", path: "/auctions/addAuction" },
      ],
    },
    {
      title: "Tickets",
      icon: "📩",
      key: "tickets",
      submenu: [{ title: "Ticket List", path: "/tickets/list" }],
    },
    {
      title: "Employees",
      icon: "🙍",
      key: "employees",
      submenu: [
        { title: "Employee List", path: "/employees/list" },
        { title: "Create Employee", path: "/employees/add" },
      ],
    },
    {
      title: "Yards",
      icon: "🏢",
      key: "yards",
      submenu: [
        { title: "Yard List", path: "/yards/list" },
        { title: "Create Yard", path: "/yards/addYard" },
      ],
    },
    {
      title: "Cases",
      icon: "🚗",
      key: "cases",
      submenu: [
        { title: "Case List", path: "/cases/list" },
        { title: "Create Case", path: "/cases/add" },
        { title: "Assign Case", path: "/cases/AssignCasesList" },
      ],
    },
  ];

  const isActive = (path) => {
    if (!path) return false;
    if (path === "/") return location.pathname === "/";
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const isSubmenuActive = (submenuItems) =>
    submenuItems && submenuItems.some((item) => isActive(item.path));

  const handleDropdownToggle = (key) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
  };

  const handleLinkClick = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
    const activeDropdown = menuItems.find(
      (m) => m.submenu && isSubmenuActive(m.submenu),
    );
    if (activeDropdown) setOpenDropdown(activeDropdown.key);
    else setOpenDropdown((prev) => prev);
  }, [location.pathname]);

  const handleLogOut = async () => {
    await dispatch(logout());
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="brand-container" onClick={() => navigate("/")}>
          <div className="brand-icon">
            <img src={brandImage} alt="mCollect brand icon" />
          </div>
          <h3 className="brand-name">mCollect Admin Panel</h3>
        </div>
      </div>

      <Nav className="flex-column sidebar-nav">
        {menuItems.map((item, index) => {
          const hasSubmenu = item.submenu;
          const isItemActive = hasSubmenu
            ? isSubmenuActive(item.submenu)
            : isActive(item.path);
          const isDropdownOpen = openDropdown === item.key;

          return (
            <div key={index} className="nav-item-wrapper">
              {hasSubmenu ? (
                <>
                  <div
                    className={`nav-link-main ${isItemActive ? "active" : ""}`}
                    onClick={() => handleDropdownToggle(item.key)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        handleDropdownToggle(item.key);
                      }
                    }}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">{item.title}</span>
                    <span
                      className={`dropdown-arrow ${
                        isDropdownOpen ? "open" : ""
                      }`}
                    >
                      ▾
                    </span>
                  </div>

                  <div className={`submenu ${isDropdownOpen ? "open" : ""}`}>
                    {item.submenu.map((subItem, subIndex) => (
                      <Link
                        key={subIndex}
                        to={subItem.path}
                        className={`submenu-item ${
                          isActive(subItem.path) ? "active" : ""
                        }`}
                        onClick={handleLinkClick}
                      >
                        <span className="submenu-dot"></span>
                        {subItem.title}
                      </Link>
                    ))}
                  </div>
                </>
              ) : (
                <Link
                  to={item.path}
                  className={`nav-link-main ${isItemActive ? "active" : ""}`}
                  onClick={handleLinkClick}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-text">{item.title}</span>
                </Link>
              )}
            </div>
          );
        })}
      </Nav>

      <div className="sidebar-footer">
        <div className="user-info mb-2">
          <div className="user-avatar">
            <span className="user-icon">👤</span>
          </div>
          <div className="user-details">
            <span className="user-role">{loginData?.name}</span>
          </div>
        </div>
        <div
          className="user-info d-flex justify-content-center align-items-center"
          onClick={() => handleLogOut()}
        >
          <div className="text-center">
            <span>Log Out</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
